import { useSearchParams } from "react-router-dom";
import { getReleases } from "../data";
import '../App.css';

export default function EpubReader() {

  const [searchParams,] = useSearchParams();
  const target = searchParams.get("target")
  const releases = getReleases()
  let url = ""
  let name = ""

  console.log(target)

  if (target) {
    for (const group of releases) {
      for (const release of group.items) {
        if (release.index === target) {
          url = "https://drive.google.com/file/d/" + release.epublink + "/preview"
          name = release.name
          console.log(url)
          break
        }
      }
    }
  }

  document.title = name + " (EPUB)"

  return (
    <div>
      <iframe id="pdfreader" className="pdfReader" src={url} />
    </div>
  );
}